<template>
  <v-container></v-container>
</template>
<script>
  import { apiResource } from '@/util/resources'

  export default {
    props: ['requestId', 'taskId'],
    created () {
      this.verifySigning()
    },
    methods: {
      verifySigning () {
        console.log('start')
        this.$store.commit('setLoading', true)
        this.$store.commit('setInitializing', true)
        this.$store.commit('clearError')

        var data = {
          RequestId: this.requestId,
          TaskId: this.taskId,
          Lang: this.$store.getters.longLocale
        }

        apiResource.post('api/reconciliation/verify', data).then((response) => {
          this.$store.commit('setLoading', false)
          this.$matomo && this.$matomo.trackEvent("Action", "Make Settlement", "Settlement Sign Completed")
          this.$store.dispatch('initialize')
          this.$router.push('/front-page')
        }).catch((error) => {
          if (error.response.data === 'aborted') {
            this.$store.commit('setMessage', { type: 'error', text: 'error.reconciliation.0', translate: true })
          } else if (error.response.data === 'error') {
            this.$store.commit('setMessage', { type: 'error', text: 'error.server.0', translate: true })
          }
          this.$store.commit('setLoading', false)
          this.$store.dispatch('initialize')
          this.$router.push('/front-page')
        })
      }
    }
  }
</script>
